import { UserLayout, TabLayout, RouteView, BlankLayout, PageView,HomeLayout } from '@/components/layouts'


/**
 * 工作站理由
 * @type { *[] }
 */
export default [
  {
    path: '/',
    redirect: '/pad/index',
  },
  {
    path: '/index',
    // name: 'work',
    component: HomeLayout,
    meta: { title: '工作站页' },
    children: [
      {
        path: '/',
        component: () => import(/* webpackChunkName: "user" */ '@/views/project/Index')
      },
    ]
  },
]
